export default {
  slug: "pycharm-data",
  code: "PCD",
  label: "PyCharm (Data)",
  shortLabel: "PyCharm",
  altLabel: "PyCharm",
  hasGrid: true,
  thumbnailColor: "#FCF84A",
  logoFamily: "data",
};
